export default __webpack_public_path__ + "static/media/education.69f31845.svg";